import AppPage from "../AppPage";
import MenuBottomBar, { MenuBarItem } from "../MenuBottomBar";
import { globals, images, utilities } from "../../styles";
import { arrow_Icon, crown_Icon } from "../../assets/icons";
import { useNavigate } from "../../hooks/useNavigate";
import { Page } from "../../types";
import { useUserId } from "../../hooks/useUserId";
import styles from "../LeaderboardSelectionPage/LeaderboardSelectionPage.module.css";
import { useGroup, useGroupLeaderboard } from "../../hooks/groups";
import { useMemo } from "react";
import { usePlayerStats } from "../../hooks/player";
import { pointsFormatter } from "../../helpers";
import LoadingSpinner from "../LoadingSpinner";

function ExpandedLeaderboardPage(props: {
  selectedGroupId: string | undefined;
}) {
  const { selectedGroupId } = props;
  const { navigate } = useNavigate();
  const userId = useUserId();
  // TODO: add limit, offset, pagination
  const { data: groupLeaderboard, isPending: isLeaderboardLoading } =
    useGroupLeaderboard(selectedGroupId);
  const { data: groupDetails, isPending: isGroupDetailsLoading } =
    useGroup(selectedGroupId);
  const { data: playerStats, isPending: isPlayerStatsLoading } =
    usePlayerStats(userId);
  const currentPlayerRank = useMemo(
    () =>
      playerStats?.ranks.find((r) => r && r.groupId === groupDetails?.groupId)
        ?.rank ?? 0,
    [playerStats?.ranks, groupDetails],
  );

  const sortedMembers = useMemo(
    () =>
      [...(groupLeaderboard?.leaderboard ?? [])].sort(
        (a, b) => a.rank - b.rank,
      ),
    [groupLeaderboard?.leaderboard],
  );
  const top3 = sortedMembers.slice(0, 3);

  const isLoading =
    isLeaderboardLoading || isPlayerStatsLoading || isGroupDetailsLoading;
  return (
    <AppPage
      className={globals["page"]}
      bottomBar={
        <MenuBottomBar
          items={[
            MenuBarItem.Home,
            MenuBarItem.News,
            MenuBarItem.Groups,
            MenuBarItem.LogOut,
          ]}
        />
      }
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <button
            className={`${globals["button-wrapper"]} ${globals["back-btn--top-left"]}`}
            onClick={() => navigate(Page.LeaderboardSelection)}
          >
            <div className={globals["back-btn"]}>
              <img src={arrow_Icon} alt="" />
            </div>
          </button>
          <div className={utilities["flex-col"]}>
            <span className={globals["gameweek_details-leaderboard"]}>
              Deadline: Saturday Jan 17 at 13:00
            </span>
            <span className={globals["gameweek-header-leaderboard"]}>
              Gameweek 5
            </span>
          </div>
          <div className={styles["expanded"]}>
            <span className={styles["expanded-title"]}>
              {groupDetails?.isLeaderboard
                ? "World Leaderboard"
                : groupDetails?.name}
            </span>
            {/* Top 3 with crowns */}
            <div className={styles["expanded-top3"]}>
              {top3.map((member) => (
                <div
                  className={styles["expanded-top3-row"]}
                  key={member.playerId}
                >
                  <div className={styles["expanded-crown-wrapper"]}>
                    <img
                      src={crown_Icon}
                      className={styles["expanded-crown"]}
                      alt=""
                    />
                    <span className={styles["expanded-crown-rank"]}>
                      {member.rank}
                    </span>
                  </div>
                  <span className={styles["expanded-top3-name"]}>
                    {member.playerId === userId ? "You" : member.username}
                  </span>
                  <span className={styles["expanded-top3-score"]}>
                    {member.score}
                  </span>
                </div>
              ))}
            </div>
            {/* Your Rank card */}
            {playerStats && (
              <div className={styles["your-rank-card"]}>
                <div className={styles["your-rank-top"]}>
                  <img
                    src={crown_Icon}
                    className={images["username-crown"]}
                    alt=""
                  />
                  <span className={styles["your-rank-label"]}>
                    Your Leaderboard Stats
                  </span>
                  <img
                    src={crown_Icon}
                    className={images["username-crown"]}
                    alt=""
                  />
                </div>
                <div className={styles["your-rank-bottom"]}>
                  <span className={styles["your-rank-value"]}>
                    Rank: {currentPlayerRank}
                  </span>
                  <span className={styles["your-rank-points"]}>
                    Points: {pointsFormatter(playerStats.totalScore)}
                  </span>
                </div>
              </div>
            )}
            {/* Full table */}
            <div className={styles["expanded-table"]}>
              <div
                className={`${styles["expanded-table-row"]} ${styles["expanded-table-header"]}`}
              >
                <span>Rank</span>
                <span>Team</span>
                <span className={styles["expanded-table-score"]}>Score</span>
              </div>
              <div className={styles["expanded-table-body"]}>
                {sortedMembers.map((member) => (
                  <div
                    className={styles["expanded-table-row"]}
                    key={member.playerId}
                  >
                    <span>{member.rank}</span>
                    <span>
                      {member.playerId === userId ? "You" : member.username}
                    </span>
                    <span className={styles["expanded-table-score"]}>
                      {member.score}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </AppPage>
  );
}

export default ExpandedLeaderboardPage;
